import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {LOTTI} from '../../configs/AppConfig';
import {CURRENT_COMPANY_LOTS} from 'constants/AuthConstant';
import DbUtils from 'utils/indexDB';
import LotsService from 'services/LottiService';
import MagazziniService from "../../services/MagazziniService";

export const initialState = LOTTI;

const DB_NAME = 'MyLotsDB';
const STORE_NAME = 'lots';
const VERSION = 1;
const LAST_SYNC_TIMESTAMP = 'LOTS_LAST_FULL_SYNC';

export const loadLots = createAsyncThunk('carica-lotti', async (data, {rejectWithValue}) => {
    console.log("[loadLots]");

    try {
        // Recupera l'ID dell'azienda corrente
        const currentCompanyId = data.documentId;

        // Recupera l'ultima azienda memorizzata e i prodotti in cache
        const lastCompanyId = localStorage.getItem(CURRENT_COMPANY_LOTS);
        const cachedLotti = await DbUtils.getAll(DB_NAME, VERSION, STORE_NAME);

        // Get the last full sync timestamp
        const lastFullSync = localStorage.getItem(LAST_SYNC_TIMESTAMP);
        const now = new Date().getTime();
        const oneDayInMs = 24 * 60 * 60 * 1000; // 24 hours
        const shouldForceFullSync = !lastFullSync || (now - parseInt(lastFullSync)) > oneDayInMs;

        // Force a full sync if:
        // 1. Company has changed
        // 2. There are no cached lots
        // 3. It's been more than a day since the last full sync
        if (currentCompanyId !== lastCompanyId || !cachedLotti || cachedLotti.length === 0 || shouldForceFullSync) {

            const response = await LotsService.getLotsByCompany(currentCompanyId);

            const lotti = response.data.map((item) => ({
                id: item.lot.id,
                documentId: item.lot.documentId,
                updatedAt: item.lot.updatedAt,
                ...item.lot,
            }));
            console.log("ddt-debug primo if",lotti)

            localStorage.setItem(LAST_SYNC_TIMESTAMP, now.toString());
            await DbUtils.clearAllAndSaveItem(lotti, DB_NAME, VERSION, STORE_NAME);

            return {lotti: lotti, company: currentCompanyId};

        } else {

            const countResponse = await LotsService.getLotsByCompanyCount(currentCompanyId);
            const serverLotsCount = countResponse.meta.pagination.total;


            if (serverLotsCount < cachedLotti.length) {
                console.log('Rilevate cancellazioni nel database remoto, eseguo sync completo...');

                const response = await LotsService.getLotsByCompany(currentCompanyId);

                const lotti = response.data.map((item) => ({
                    id: item.lot.id,
                    documentId: item.lot.documentId,
                    updatedAt: item.lot.updatedAt,
                    ...item.lot,
                }));

                localStorage.setItem(LAST_SYNC_TIMESTAMP, now.toString());
                await DbUtils.clearAllAndSaveItem(lotti, DB_NAME, VERSION, STORE_NAME);


                console.log("ddt-debug primo else primo if",lotti)
                return {lotti: lotti, company: currentCompanyId};
            }


            const latestUpdatedAt = cachedLotti.reduce((latest, lot) => {
                const updatedDate = new Date(lot.updatedAt);
                return updatedDate > latest ? updatedDate : latest;
            }, new Date(0));


            const response = await LotsService.getLotsByCompanyAfter(currentCompanyId, latestUpdatedAt.toISOString());

            const updatedProducts = response.data.map((item) => ({
                id: item.lot.id,
                documentId: item.lot.documentId,
                updatedAt: item.lot.updatedAt,
                ...item.lot,
            }));

            if (updatedProducts.length > 0) {
                const mergedProducts = DbUtils.mergeItems(cachedLotti, updatedProducts);
                await DbUtils.saveItem(mergedProducts, DB_NAME, VERSION, STORE_NAME);
                console.log("ddt-debug primo else if mergedProducts",mergedProducts)
                return {lotti: mergedProducts, company: currentCompanyId};
            } else {
                console.log("ddt-debug primo else else cachedLotti",cachedLotti)
                return {lotti: cachedLotti, company: currentCompanyId};
            }
        }
    } catch (err) {
        console.error(err);
        return rejectWithValue('ERRORE');
    }
});


export const loadLotsNoCache = createAsyncThunk('carica-lotti-no-cache', async (data, {rejectWithValue}) => {
        console.log("[loadLotsNoCache]");

        try {
            console.log("data", data)

            const currentCompanyId = data.documentId;

            const now = new Date().getTime();

            const response = await LotsService.getLotsByCompany(currentCompanyId);

            const lotti = response.data.map((item) => ({
                id: item.lot.id,
                documentId: item.lot.documentId,
                updatedAt: item.lot.updatedAt,
                ...item.lot,
            }));

            localStorage.setItem(LAST_SYNC_TIMESTAMP, now.toString());

            await DbUtils.clearAllAndSaveItem(lotti, DB_NAME, VERSION, STORE_NAME);

            return {lotti: lotti, company: currentCompanyId};
        } catch
            (err) {
            console.error(err);
            return rejectWithValue('ERRORE');
        }
    })
;


/*export const resetLots = createAsyncThunk('reset-lots', async (data, {rejectWithValue}) => {
    console.log("[resetLots]");

    try {
        // Recupera l'ID dell'azienda corrente
        const currentCompanyId = data.documentId;

        console.log('Nuova azienda o nessuna cache trovata, fetch completo dal server...');
        const response = await LotsService.getLotsByCompany(currentCompanyId);
        console.log("response: ", response)

        const lotti = response.data.map((item) => ({
            id: item.lot.id,
            documentId: item.lot.documentId,
            updatedAt: item.lot.updatedAt,
            ...item.lot,
        }));

        // Update last full sync timestamp
        const now = new Date().getTime();
        localStorage.setItem(LAST_SYNC_TIMESTAMP, now.toString());

        // Salva i prodotti e l'ID dell'azienda corrente
        await DbUtils.clearAllAndSaveItem(lotti, DB_NAME, VERSION, STORE_NAME);
        console.log("lotti: ", lotti)

        return {lotti: lotti, company: currentCompanyId};

    } catch (err) {
        console.error(err);
        return rejectWithValue('ERRORE');
    }
});*/

export const createLotsForProduct = createAsyncThunk('crea-lotti-per-prodotto', async (body, {rejectWithValue}) => {
    try {
        const response = await LotsService.createLotsForProduct(body);
        return response.data;
    } catch (err) {
        console.error("err", err);
        return rejectWithValue('ERRORE');
    }
});

export const lotti = createSlice({
    name: 'lotti', initialState, reducers: {}, extraReducers: (builder) => {
        builder
            .addCase(loadLots.pending, (state) => {
                state.loadingLots = true
                state.loadedLots = false
                state.errorLots = false
            })
            .addCase(loadLots.fulfilled, (state, action) => {
                state.loadingLots = false
                state.lots = action.payload.lotti
                state.errorLots = false
                state.loadedLots = true
                state.currentCompany = action.payload.company
                localStorage.setItem(CURRENT_COMPANY_LOTS, action.payload.company)

            })
            .addCase(loadLots.rejected, (state, action) => {
                state.loadingLots = false
                state.lots = []
                state.loadedLots = true
                state.errorLots = true
            })
           /* .addCase(resetLots.pending, (state) => {
                state.loadingLots = true
                state.loadedLots = false
                state.errorLots = false
            })
            .addCase(resetLots.fulfilled, (state, action) => {
                state.loadingLots = false
                state.lots = action.payload.lotti
                state.errorLots = false
                state.loadedLots = true
                state.currentCompany = action.payload.company
                localStorage.setItem(CURRENT_COMPANY_LOTS, action.payload.company)

            })
            .addCase(resetLots.rejected, (state, action) => {
                state.loadingLots = false
                state.lots = []
                state.loadedLots = true
                state.errorLots = true
            })*/
            .addCase(createLotsForProduct.pending, (state) => {
                state.creatingLots = true
                state.createdLots = false
                state.errorCreateLots = false
            })
            .addCase(createLotsForProduct.fulfilled, (state, action) => {
                state.creatingLots = false
                state.createdLots = true
                state.errorCreateLots = false
            })
            .addCase(createLotsForProduct.rejected, (state, action) => {
                state.creatingLots = false
                state.createdLots = false
                state.errorCreateLots = true
            })
            .addCase(loadLotsNoCache.pending, (state) => {
                state.loadingLots = true
                state.loadedLots = false
                state.errorLots = false
            })
            .addCase(loadLotsNoCache.fulfilled, (state, action) => {
                state.loadingLots = false
                state.lots = action.payload.lotti
                state.errorLots = false
                state.loadedLots = true
                state.currentCompany = action.payload.company
                localStorage.setItem(CURRENT_COMPANY_LOTS, action.payload.company)
            })
            .addCase(loadLotsNoCache.rejected, (state, action) => {
                state.loadingLots = false
                state.lots = []
                state.loadedLots = true
                state.errorLots = true
            })
    }
})

export default lotti.reducer;
